import ScrollMagic from 'scrollmagic'
// import 'debug.addIndicators';
// import 'animation.gsap';

export const controller = new ScrollMagic.Controller()
